exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".room-pax-info{display:inline-flex;align-items:center;margin:0 -2px}.room-pax-info__room-type{margin:0 2px;font-size:14px;line-height:17px;font-weight:300;text-transform:uppercase}.room-pax-info__paxes{margin:0 2px}.room-pax-info--reverse{flex-direction:row-reverse}.room-pax-info--reverse .room-pax-info__room-type{margin:0 0 0 4px}.room-pax-info--full-width{justify-content:space-between;width:100%}.room-pax-info--full-width .room-pax-info__room-type{margin:0}body[dir=rtl] .room-pax-info--reverse .room-pax-info__room-type {\n  margin: 0 4px 0 0;\n}\n", ""]);

// exports
